//angular modules
import { NgModule, LOCALE_ID, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from "@angular/http";
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//custom modules
import { AuthModule } from './_authentication/auth.module';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './routing/routing';

// Anugular2 Progress
import { CgBusyModule } from 'angular-busy2';
import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressHttpModule } from '@ngx-progressbar/http';
import { TranslateModule, TranslateLoader, MissingTranslationHandlerParams, TranslateParser, TranslateService, MissingTranslationHandler } from '@ngx-translate/core';
import localeDe from '@angular/common/locales/de';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Angular-Notifications
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SimpleNotificationsModule } from 'angular2-notifications';

//components
import { AppComponent } from './app.component';
import { LicenseManager } from 'ag-grid-enterprise/main'; //aggrid enterprise features
import { GlobalsServiceConfig } from "./shared/shared";
import { registerLocaleData } from '@angular/common';
import { LoggerService } from './core/service/logger.service';
import { extendedHttpProvider } from './_authentication/http/http';
import { VertragModule } from './_vertrag/vertrag.module';

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export class AppMissingTranslationHandler implements MissingTranslationHandler {
    translate: TranslateService;
    logger: LoggerService;

    constructor(private injector: Injector, private parser: TranslateParser) {
    }

    handle(params: MissingTranslationHandlerParams) {
        if (this.translate == null) {
            this.translate = this.injector.get(TranslateService);
        }

        if (this.logger == null) {
            this.logger = this.injector.get(LoggerService);
        }

        return this.translate.get('KeyNotFound', { key: params.key }).subscribe((res: string) => {
            this.logger.log(res);
            return res;
        });
    }
}

@NgModule({
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpModule,
        HttpClientModule,

        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),

        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        SimpleNotificationsModule.forRoot(),
        CgBusyModule,
        NgProgressModule.forRoot({
            color: "#ff0000"
        }),
        NgProgressHttpModule,

        // COMPONENTS MODULES
        AuthModule.forRoot(),
        SharedModule.forRoot(),
        VertragModule.forRoot(),
    ],
    declarations: [AppComponent],
    providers: [
        extendedHttpProvider,
        {
            provide: LOCALE_ID,
            useValue: 'de'
        },
        {
            provide: MissingTranslationHandler,
            deps: [Injector, TranslateParser],
            useClass: AppMissingTranslationHandler
        },
    ]
})

export class AppModule {
    constructor(globalsServiceConfig: GlobalsServiceConfig, translate: TranslateService) {
        LicenseManager.setLicenseKey("Neue_Informationstechnologien_GmbH_MultiApp_1Devs10_July_2020__MTU5NDMzNTYwMDAwMA==b84550c35875c8f5eace49a1767f00a1");
        globalsServiceConfig.GridOptions = {
            suppressPaginationPanel: false,
            suppressCellSelection: true,
            rowSelection: 'single',
            pagination: true,
            paginationPageSize: 30,
            paginationStartPage: 0,
            rowGroupPanelShow: 'never',
            maxConcurrentDatasourceRequests: 1,
            cacheBlockSize: 30,
            maxBlocksInCache: 2,
            suppressContextMenu: true,
        };

        registerLocaleData(localeDe);

        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang('de');

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use('de');
    }

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts